import PropTypes from 'prop-types';
import React from 'react';
import StyleSheet from 'utilities/StyleSheet';
import CardHeader from '../shared/CardHeader';
import CardRender from '../shared/CardRender';

class DocumentView extends React.Component {
  getStyleSheet() {
    return StyleSheet({
      container: {
        padding: '8px 16px',
      },
      contentContainer: {
        display: 'flex',
      },
      content: {
        margin: 'auto',
      },
    });
  }

  render() {
    const styles = this.getStyleSheet();
    const {card, cardRender} = this.props;
    const img = cardRender ? (
      <img src={cardRender.data.previewUrl} style={styles.content} />
    ) : null;

    return (
      <div style={styles.container}>
        <CardHeader card={card} />
        <div style={styles.contentContainer}>{img}</div>
      </div>
    );
  }
}

DocumentView.propTypes = {
  card: PropTypes.object.isRequired,
};

export default CardRender(DocumentView, () => ({
  imageAsDocument: true,
}));
